<template>
  <div class="distances-section">
    <div v-for="distance in distances"
         :title="distance.targetName"
         class="distance"
    >
      <span>
        <i :class="'fas '+ distance.fas +' fa-sm'" ></i>
      </span>
      <span>
        {{getDistance(distance.distance)}}
      </span>
    </div>
  </div>
</template>
<script>
  //import formatter from '@/components/global/mixins/formatterMethods'
    export default {
      //mixins: [formatter],
      name: 'distances',
      props: {
          distances: {
              type: Array,
              required: true
          }
      },

      methods: {
        getDistance (distance) {
          let unit = 'm'

          if (distance >= 1000) {
            unit = 'km'
            distance = (Math.round(distance / 1000 * 100) /100).toFixed(1).replace('.', ',')

            // if (distance.toString().slice(-1) === '0') {
            //     distance = Math.round(distance)
            // }
            if (distance.toString().slice(-1) === '0') {
                distance = parseInt(distance)
            }
          }
          return distance + ' ' + unit
        }
      }
    }
</script>

<style scoped lang="scss">
    span {
        margin-left: 1rem;
    }
</style>
